
import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import EsteiraComponent from './EsteiraComponent';
/* eslint-disable */


function Quarto(props) {
	const {step, setStep, setSubTitle, setTitle, submitLogin} = props;

	return (
		<div className="content-center">

			<Row className="rowButton px-4">
				<Col>
					<Button
						color="primary"
						className="buttonComponentOutline px-5"
						onClick={() => {
							submitLogin()
						}}>
						CONTINUAR
					</Button>
				</Col>
			</Row>
			<EsteiraComponent step={step} />
		</div>
	);
}

export default Quarto;
